/**
 * Prevents default scroll behavior for a specific hash link.
 *
 * This function targets the anchor element with class `ot-sdk-show-settings` and `href="#"`,
 * and prevents the default scroll-to-top behavior when it is clicked. This is useful
 * when the link is used to trigger a modal or settings panel via JavaScript instead of navigation.
 */
const preventHashlinkScroll = () => {
	const anchor = document.querySelector('a.ot-sdk-show-settings[href="#"]');
	if (anchor) {
		anchor.addEventListener('click', (event) => {
			event.preventDefault();
		});
	}
};

export default preventHashlinkScroll;
